<template>
  <div class="warning-block"
       :class="{
         'red-background': !accountingPeriodClosedError && severity === 'error',
         'orange-background': !accountingPeriodClosedError && severity === 'warn',
         'background-theme-color': accountingPeriodClosedError,
         'warning-block--fixed': fixedToTop,
         'warning-block--modal': !fixedToTop,
       }">
    <div class="text"
         :class="{'large-font': !accountingPeriodClosedError, 'white-font': accountingPeriodClosedError}"
         :role="severity === 'error' || accountingPeriodClosedError ? 'alert' : 'status'">
      <i class="pi pi-exclamation-triangle warning-block__icon" aria-hidden="true"></i>
      <span class="warning-block__message">{{ text }}</span>
    </div>
    <slot name="button"/>
  </div>
</template>

<script>
export default {
  name: 'MessageBar',
  props: {
    text: {
      type: String,
      default: '',
    },
    severity: String,
    fixedToTop: {
      type: Boolean,
      default: true,
    },
    accountingPeriodClosedError: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.warning-block {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 8px;

  .text {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    min-width: 0;
    min-height: 26px;
  }

  .large-font {
    font-size: 1.14rem;
  }
}

.warning-block__icon {
  flex: none;
  margin-right: 5px;
  font-size: 1.2rem;
}

.warning-block__message {
  overflow-wrap: anywhere;
}

.warning-block--fixed {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  box-sizing: border-box;
  width: max-content;
  max-width: min(760px, calc(100% - 24px));
  padding: 10px 16px;
  border: 1px solid #dce3ea;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 6px 22px rgba(20, 38, 56, 0.18);
  color: #344054;
  z-index: 999999;

  .text {
    text-align: left;
    font-size: 1rem;
    line-height: 1.4;
  }

  .warning-block__icon {
    //color: currentColor;
    font-size: 1rem;
  }
}

.warning-block--modal {
  position: relative;
  //left: -21px;
  //width: calc(100% + 42px);
  //min-height: 42px;
  box-sizing: border-box;
  justify-content: flex-start;
  padding: 5px 14px;
  margin-bottom: 18px;
  margin-top: -10px;
  font-weight: 500;
  //border-left: 5px solid var(--primary-color);
  border-radius: 3px;

  .text {
    justify-content: flex-start;
    text-align: left;
    font-size: 1rem;
    //line-height: 1.4;
  }
}

.red-background {
  background-color: #e60017;
  font-weight: 500;
  color: #fff;
}

.orange-background {
  background-color: #fd7e14;
  font-weight: 500;
  color: #fff;
}

.white-font {
  color: #fff;
}

.warning-block--fixed.orange-background {
  border-color: #efd4a0;
  background: #fff8e9;
  color: #795014;
}

.warning-block--fixed.red-background {
  border-color: #efc4c4;
  background: #fff6f5;
  color: #a32929;
}

.warning-block--fixed.background-theme-color {
  border-color: #bbd8ec;
  background: #f2f9fd;
  color: #145a7d;

  .white-font {
    color: inherit;
  }
}

.warning-block--modal.orange-background {
  border-bottom: 1px solid #efd4a0;
  background: #fff8e9;
  color: #795014;
}

.warning-block--modal.red-background {
  border-bottom: 1px solid #edc5c2;
  background: #fff2f1;
  color: #a32929;
}

.warning-block--modal.background-theme-color {
  background: color-mix(in srgb, var(--primary-color) 75%, transparent);
  //color: var(--text-color);
  color: #fff;

  .white-font {
    //color: inherit;
  }

  .warning-block__icon {
    //color: var(--primary-color);
  }

  //:deep(.p-button.p-button-outlined) {
  //  background: var(--primary-color);
  //  border-color: var(--primary-color);
  //  color: var(--primary-color-text, #fff) !important;
  //}
  //
  //:deep(.p-button.p-button-outlined:hover) {
  //  filter: brightness(0.92);
  //}
}
</style>
